// src/components/MainView.tsx
import React, { useState,useEffect } from "react";
import { useUI } from "../context/UIContext";
import ProjectChat from "./ProjectChat";
import IssueChat from "./IssueChat";
import IssueDetails from "./IssueDetails";
import clsx from "clsx";
import ProjectGantt from "./ProjectGantt"; // ✅ REQUIRED
import MaterialStatementReport from "./FinalReport/MaterialStatementReport";
import DprReport from "./DailyReport/DprReport";


//need to check report showing wrong data
import DprCumulativeReport from "./DailyReport/DprCumulativeReport";



//project dashboard import
import ProjectDashboard from "./ProjectDashboard";

import DRSNotesReport from "./FinalReport/DRSNotesReport";


//feb 16 today trial 
import DailyProgressDprReport from "./DailyReport/DailyProgressDprReport";

//import 18 feb
import LookAheadProgressReport from "./DailyReport/LookAheadProgressReport";



import WorksQtyReport from "./WorksReport/WorksQtyReport";
//import GroupReportController from "./WorksReport/GroupReportController";
import GroupProgressRangeReport from "./WorksReport/GroupProgressRangeReport";
import MarkwiseProgressReport from "./WorksReport/MarkwiseProgressReport";
import MaterialStatementVendorWiseReport from "./FinalReport/MaterialStatementVendorWiseReport";
import ManPowerStatementVendorWiseReport from "./FinalReport/ManPowerStatementVendorWiseReport";
import ManPowerStatementResourceWiseReport from "./FinalReport/ManPowerStatementResourceWiseReport";
import EquipmentStatementResourceWiseReport from "./FinalReport/EquipmentStatementResourceWiseReport";
import DrawingsReport from "./FinalReport/DrawingsReport";
import EquipmentStatementVendorWiseReport from "./FinalReport/EquipmentStatementVendorWiseReport";
import WeatherKeywordReport from "./FinalReport/WeatherKeywordReport";
import TaskReportView from "./TaskReportView";
import CompanyAddUser from "../CompanyAddUser";

import { useAuth } from "../context/AuthContext";
import NewIssueModal from "./NewIssueModal";
import ProjectReports from "./ProjectReports";
import AllIssues from "../components/AllIssues";



export default function MainView({
  isMobile,
  onBack, 
}: {
  isMobile?: boolean;
  onBack?: () => void;
}) {
  const {
    selectedProjectId,
    //
    selectedProjectName,
    
    selectedIssueId,
    viewMode,
    setViewMode,
    selectedIssueTitle,
    setSelectedIssueId,
    setSelectedIssueTitle,
    //
    pushUIState, // ✅ ADD THIS

    setSelectedProjectId,
  setSelectedProjectName,
  } = useUI();

  const { user } = useAuth();

  const [showNewIssueModal, setShowNewIssueModal] = useState(false);
  const [showMenu, setShowMenu] = useState(false);

  const goToHome = () => {
  pushUIState();

  setSelectedProjectId(null);   // ⭐ show All Projects (Sidebar)
  setSelectedProjectName(null);
  setSelectedIssueId(null);
  setSelectedIssueTitle(null);
};
  //
// ✅ THIS BLOCK


/*const role = localStorage.getItem("role")?.toLowerCase();

if (role === "superadmin" && viewMode !== "superadmin") {
  setSelectedProjectId(null);   // ⭐ ADD THIS
  setSelectedIssueId(null);     // ⭐ ADD THIS
  setViewMode("superadmin");
  return null;
}*/
/*const savedViewMode = localStorage.getItem("viewMode");

if (savedViewMode === "superadmin" && viewMode !== "superadmin") {
  setSelectedProjectId(null);
  setSelectedIssueId(null);
  setViewMode("superadmin");
  return null;
}*/



// ✅ ADD THIS BLOCK HERE
/*useEffect(() => {
  const role = localStorage.getItem("role")?.toLowerCase();

  if (role === "superadmin") {
    setSelectedProjectId(null);   // ⭐ IMPORTANT
    setSelectedIssueId(null);     // ⭐ IMPORTANT
    setViewMode("superadmin");
  }
}, [user]);*/





  /* ------------------------------------------------
      ISSUE MODE (Chat / Details Tabs)
  -------------------------------------------------- */
  if (selectedIssueId) {
    return (      // flex flex-col h-full max-h-full overflow-hidden
      //<div className=" flex flex-col h-full max-h-full overflow-hidden"> 
            // <div className="flex flex-col h-full"> // second correct code
              <div className="flex flex-col h-full min-h-0">
            


        {/* Sticky Issue Header */}
         
     {/* <div className="sticky top-0 bg-white border-b px-5 h-14 z-20 shadow-sm flex justify-between items-center"> */}
     {/*  <div className="sticky top-0 bg-white border-b px-4 py-3 z-20 shadow-sm flex items-center justify-between">*/}
   {/* <div className="sticky top-0 bg-white border-b px-5 h-14 z-20 shadow-sm flex items-center justify-between md:justify-between">*/}
   {/*<div className="sticky top-0 bg-white border-b px-5 min-h-14 py-2 z-20 shadow-sm flex items-start justify-between md:justify-center relative">*/}
   <div className="sticky top-0 bg-white border-b px-3 md:px-5 py-2 z-20 shadow-sm flex flex-col md:flex-row md:items-center md:justify-between gap-2">
        

          
           {/*<div className="flex items-center gap-2">
           
  
            
            
            
            
            onBack && (
                <button 
                  onClick= {onBack}

                 
  
                 
                  
                  className="px-3 py-1 bg-gray-200 rounded text-sm"
                  

                  //px-3 py-1 bg-gray-200 rounded text-sm
                >
                  ←
                </button>
                    
            )}
          </div>*/}
         
         {/* old issuechat code block before the changes with logo only */}
        
        {/*<div className="flex items-center gap-2">*/}
       
       {/* <div className="flex items-center gap-2 shrink-0">*/}
       
       {/*<div className=
       //"flex items-center gap-2 shrink-0 md:w-[150px]">
       //"flex items-center gap-2 shrink-0 mt-1">
       "flex items-center justify-between w-full md:w-auto">

  {isMobile && (
    <img
      src="/icon.png"
      alt="Baevr"
      //className="h-8 cursor-pointer"
      className="h-8 cursor-pointer md:hidden"
      onClick={goToHome}
    />
  )}

  {onBack && (
    <button
      onClick={onBack}
      className="px-3 py-1 bg-gray-200 rounded text-sm"
    >
      ←
    </button>
  )}

</div>*/}

<div className="flex items-center justify-between w-full md:w-auto">


  {/* LEFT */}
  {/*<div className="flex items-center gap-2">*/}
  <div className="flex items-center gap-3 shrink-0">
    {isMobile && (
      <img
        src="/icon.png"
        alt="Baevr"
        className="h-8 cursor-pointer md:hidden"
        onClick={goToHome}
      />
    )}

    {onBack && (
      <button
        onClick={onBack}
        className="px-3 py-1 bg-gray-200 rounded text-sm"
      >
        ←
      </button>
    )}
  </div>

  {/* RIGHT (MOBILE ONLY) */}
  <div className="flex items-center gap-2 md:hidden">

    {/*<div className="flex gap-1">*/}
    <div className="flex gap-2 ml-2">
      {viewMode !== "issue-chat" && (
        <button
          className="px-2 py-1 text-xs bg-blue-600 text-white rounded"
          onClick={() => {
            pushUIState();
            setViewMode("issue-chat");
          }}
        >
          💬 Chat
        </button>
      )}

      {viewMode !== "issue-details" && (
        <button
          className="px-2 py-1 text-xs bg-blue-600 text-white rounded"
          onClick={() => {
            pushUIState();
            setViewMode("issue-details");
          }}
        >
          📄 Details
        </button>
      )}
    </div>

   {/* <div className="text-sm text-gray-600 whitespace-nowrap">
      👤 {user?.userName ?? "User"}
    </div>*/}
    {/*<div className="text-sm text-gray-600 truncate max-w-[120px]">*/}
    <div className="md:hidden text-xs text-gray-500 px-2 break-all">
  👤 {user?.userName ?? "User"}
</div>


  </div>

 

</div>
 {/*<div className="font-semibold text-sm text-gray-800 leading-snug break-words md:hidden px-2">*/}
{/* <div className="font-semibold text-base md:text-lg text-gray-800 leading-snug break-words md:hidden px-2">*/}
 <div className="font-semibold text-xl text-gray-800 leading-snug break-words md:hidden px-2 mt-1">
  {selectedIssueTitle ?? `Issue #${selectedIssueId}`}
</div>

          {/*<div>
            <div className="font-semibold text-lg text-gray-800 truncate max-w-[300px]"> */}
            {/*<div className="font-semibold text-base md:text-lg text-gray-800 break-words leading-snug">*/}
              
              {/*{selectedIssueTitle ?? `Issue #${selectedIssueId}`}
            </div>
          </div>*/}

          {/*<div className="flex-1 min-w-0 px-2">*/}
         {/* <div className="flex-1 min-w-0 px-2 md:text-center">*/}
         
         {/*<div className="hidden md:flex flex-1 min-w-0 px-2 justify-center">*/}
        {/* <div className="hidden md:flex items-center justify-center gap-4 flex-1">*/}
        <div className="hidden md:flex items-center justify-center md:flex-1">
  
  {/*//"font-semibold text-sm md:text-lg text-gray-800 truncate"
  //"font-semibold text-sm md:text-lg text-gray-800 md:truncate break-words"*/}
 {/*<div className="font-semibold text-sm md:text-lg text-gray-800 break-words md:truncate text-left md:text-center">*/}

      {/* TITLE */}
  <div className="font-semibold text-lg text-gray-800 truncate text-center">
    {selectedIssueTitle ?? `Issue #${selectedIssueId}`}
  </div>

 
</div>

 {/* BUTTON */}
  {/*<div>
    {viewMode !== "issue-chat" && (
      <button
        className="px-3 py-1 rounded-lg text-sm bg-blue-600 text-white"
        onClick={() => {
          pushUIState();
          setViewMode("issue-chat");
        }}
      >
        💬 Chat
      </button>
    )}

    {viewMode !== "issue-details" && (
      <button
        className="px-3 py-1 rounded-lg text-sm bg-blue-600 text-white"
        onClick={() => {
          pushUIState();
          setViewMode("issue-details");
        }}
      >
        📄 Details
      </button>
    )}
  </div>*/}

  {/*<div className="hidden md:flex items-center justify-center min-w-[140px]">*/}
  <div className="hidden md:flex items-center justify-center md:flex-1">
  {viewMode !== "issue-chat" && (
    <button
      className="px-3 py-1 rounded-lg text-sm bg-blue-600 text-white"
      onClick={() => {
        pushUIState();
        setViewMode("issue-chat");
      }}
    >
      💬 Chat
    </button>
  )}

  {viewMode !== "issue-details" && (
    <button
      className="px-3 py-1 rounded-lg text-sm bg-blue-600 text-white"
      onClick={() => {
        pushUIState();
        setViewMode("issue-details");
      }}
    >
      📄 Details
    </button>
  )}
</div>
{/*<div className="hidden md:flex items-center justify-end min-w-[120px]">*/}
<div className="hidden md:flex items-center justify-end md:flex-1">
  <div className="text-sm text-gray-600 whitespace-nowrap">
    👤 {user?.userName ?? "User"}
  </div>
</div>

         {/*<div className="flex gap-2">*/}
        
        {/* <div className="flex gap-1 md:gap-2 shrink-0">
            {viewMode !== "issue-chat" && (
            <button
              className={clsx(
               // "px-3 py-1 rounded-lg text-sm bg-blue-600 text-white"
               "px-2 py-1 md:px-3 md:py-1 rounded-lg text-xs md:text-sm bg-blue-600 text-white"
                  
              )}
              //onClick={() => setViewMode("issue-chat")}
                // back button add
              onClick={() => {
              pushUIState();
             setViewMode("issue-chat");
            }}

            >
              💬 Chat
            </button>
            )}
            {viewMode !== "issue-details" && (
            <button
              className={clsx(
                //"px-3 py-1 rounded-lg text-sm bg-blue-600 text-white"
                  "px-2 py-1 md:px-3 md:py-1 rounded-lg text-xs md:text-sm bg-blue-600 text-white"
                  
              )}
             // onClick={() => setViewMode("issue-details")}
             onClick={() => {
           pushUIState();
          setViewMode("issue-details");
            }}

            >
              📄 Details
            </button>
            )}
          </div>

          <div className="flex items-center gap-2 text-sm text-gray-600">
            👤 {user?.userName ?? "User"}
          </div> 
          */}
          
          
          {/*className="flex items-center gap-2 shrink-0 md:w-[250px] md:justify-end"*/
         /* className="flex items-start md:items-center gap-2 shrink-0 md:w-[250px] md:justify-end mt-1 md:mt-0"*/}
        {/*<div className="flex items-center gap-2">

  <div className="flex gap-1 md:gap-2">
    {viewMode !== "issue-chat" && (
      <button
        className="px-2 py-1 md:px-3 md:py-1 rounded-lg text-xs md:text-sm bg-blue-600 text-white"
        onClick={() => {
          pushUIState();
          setViewMode("issue-chat");
        }}
      >
        💬 Chat
      </button>
    )}

    {viewMode !== "issue-details" && (
      <button
        className="px-2 py-1 md:px-3 md:py-1 rounded-lg text-xs md:text-sm bg-blue-600 text-white"
        onClick={() => {
          pushUIState();
          setViewMode("issue-details");
        }}
      >
        📄 Details
      </button>
    )}
  </div>

  <div className="text-sm text-gray-600 whitespace-nowrap">
    👤 {user?.userName ?? "User"}
  </div>

</div>*/}
        </div>

        {/* ✅ ADD HERE */}
{/*<div className="font-semibold text-sm text-gray-800 leading-snug break-words md:hidden px-2">
  {selectedIssueTitle ?? `Issue #${selectedIssueId}`}
</div>*/}

        {/* Issue Content */}
        {/*</div> <div className="flex-1 overflow-hidden">*/}
      {/*<div className="flex-1 min-h-0 overflow-y-auto">*/}
      {/*<div className="flex-1 min-h-0 overflow-y-auto p-3">*/}
            
            
           {/*  <div className="flex-1 min-h-0  p-3">


          {viewMode === "issue-chat" && <IssueChat taskId={selectedIssueId} />}
          {viewMode === "issue-details" && (
            <IssueDetails
              projectId={selectedProjectId!}
              taskId={selectedIssueId!}
            />
          )}
          
        </div> */}


        {/* <div className="flex-1 min-h-0 relative p-3">

 
  <div
    className={viewMode === "issue-chat" ? "block h-full" : "hidden"}
  >
    <IssueChat taskId={selectedIssueId!} />
  </div>

  
  <div
    className={viewMode === "issue-details" ? "block h-full" : "hidden"}
  >
    <IssueDetails
      projectId={selectedProjectId!}
      taskId={selectedIssueId!}
    />
  </div>

</div> */}
<div className="flex-1 min-h-0 relative p-3">
  {viewMode === "issue-chat" && (
    <IssueChat key={`chat-${selectedIssueId}`} taskId={selectedIssueId!} />
  )}

  {viewMode === "issue-details" && (
    <IssueDetails
      key={`details-${selectedProjectId}-${selectedIssueId}`}
      projectId={selectedProjectId!}
      taskId={selectedIssueId!}
    />
  )}
</div>
        
      </div>

    );
  }

  // ✅ SUPERADMIN VIEW
{/*if (viewMode === "superadmin") {
 // if (localStorage.getItem("userType") !== "superadmin") {
 //if (localStorage.getItem("role")?.toLowerCase() !== "superadmin") {
 if (localStorage.getItem("userType")?.toLowerCase() !== "superadmin") {
    return <div className="p-4 text-red-500">Access denied</div>;
  }

  return <CompanyAddUser />;
}*/}

  /* ------------------------------------------------
        NO PROJECT SELECTED
  -------------------------------------------------- */
  if (!selectedProjectId) {
    return <div className="text-gray-500 p-4">Select a project to begin</div>;
  }

  /* ------------------------------------------------
        PROJECT MODE (Chat / Dashboard / New Issue / Reports)
  -------------------------------------------------- */
  return (
  //  <div className="flex flex-col h-full max-h-full overflow-hidden">
      //<div className="flex flex-col h-full"> second
      <div className="flex flex-col h-full min-h-0">

      {/* Sticky Project Header */}
      
      
     <div className="sticky top-0 bg-white border-b px-5 h-14 z-20 shadow-sm flex justify-between items-center">
     
     {/*<div className="sticky top-0 bg-white border-b px-3 md:px-5 py-2 md:h-14 z-20 shadow-sm flex flex-col md:flex-row md:justify-between md:items-center">*/}

       {/* ✅ ADD LOGO HERE (NOT inside onBack) */}
  {isMobile && (
    <img
      src="/icon.png"
      alt="Baevr"
      className="h-8 cursor-pointer"
      onClick={goToHome}
    />
  )}

        
        {    onBack && (
          <div className="p-2 border-b flex items-center gap-2 bg-white shadow-sm">
            <button
              onClick= {onBack}
    
              
              
              className="px-3 py-1 bg-gray-200 rounded text-sm"
              
              
              //px-3 py-1 bg-gray-200 rounded text-sm
            >
              ←
            </button>
            
          </div>
        )}
        {isMobile && (
          <button
            className="px-3 py-1 bg-gray-200 rounded"
            onClick={() => setShowMenu(true)}
          >
            ☰
          </button>
        )}
          {/* Dropdown menu */}
          {showMenu && (
            <div className="absolute right-2 top-12 bg-white border rounded shadow-md z-50">
              <button className="block px-4 py-2 hover:bg-gray-100"
              // onClick={() => setViewMode("project-chat")}
               onClick={() => {
               pushUIState();
              setViewMode("project-chat");
              setShowMenu(false); // ✅ CLOSE MENU
               }}
              >
                Chat
              </button>
              <button className="block px-4 py-2 hover:bg-gray-100" 
              //onClick={() => setViewMode("project-dashboard")}
              onClick={() => {
               pushUIState();
             setViewMode("project-dashboard");
             setShowMenu(false); // ✅ CLOSE MENU
}}

              >
                Dashboard
              </button>
              <button className="block px-4 py-2 hover:bg-gray-100" 
              //onClick={() => setViewMode("project-reports")}
              onClick={() => {
             pushUIState();
             setViewMode("project-reports");
             setShowMenu(false); // ✅ CLOSE MENU
              }}

              
              >
                Reports
              </button>
              <button className="block px-4 py-2 hover:bg-gray-100" 
              onClick={() =>{
                 setShowNewIssueModal(true);
                  setShowMenu(false); // ✅ CLOSE MENU
              }}>
                + New Issue
              </button>
            </div>
          )}
        
        <div className="font-semibold text-lg text-gray-800">
          {selectedProjectName || `Project #${selectedProjectId}`}
          
        </div>
        
        {!isMobile && (
        <div className="flex gap-2">
          <button
            className={clsx(
             /*  "px-3 py-1 rounded-lg text-sm",
              viewMode === "project-chat"
                ? "bg-blue-600 text-white"
                : "bg-gray-200 text-gray-700" */
                "px-3 py-1.5 rounded-lg text-sm border transition-colors",
viewMode === "project-chat"
  ? "bg-gray-100 border-gray-300 text-gray-800"
  : "bg-white border-gray-200 text-gray-700 hover:bg-gray-50"
            )}
            //onClick={() => setViewMode("project-chat")}

              onClick={() => {
              pushUIState();
              setViewMode("project-chat");
}}

          >
            💬 Chat
          </button>

          <button
            className={clsx(
             /*  "px-3 py-1 rounded-lg text-sm",
              viewMode === "project-dashboard"
                ? "bg-blue-600 text-white"
                : "bg-gray-200 text-gray-700" */
                "px-3 py-1.5 rounded-lg text-sm border transition-colors",
viewMode === "project-dashboard"
  ? "bg-gray-100 border-gray-300 text-gray-800"
  : "bg-white border-gray-200 text-gray-700 hover:bg-gray-50"
            )}
           // onClick={() => setViewMode("project-dashboard")}

            onClick={() => {
          pushUIState();
          setViewMode("project-dashboard");
            }}


          >
            📊 Dashboard
          </button>

          <button
            //className="px-3 py-1 rounded-lg text-sm bg-green-600 text-white hover:bg-green-700"
            className="px-3 py-1.5 rounded-lg text-sm bg-white border border-gray-200 text-gray-700 hover:bg-gray-50 transition-colors"
            onClick={() => setShowNewIssueModal(true)}
          >
            ➕ New Issue
          </button>

          <button
            className={clsx(
             /*  "px-3 py-1 rounded-lg text-sm",
              viewMode === "project-reports"
                ? "bg-blue-600 text-white"
                : "bg-gray-200 text-gray-700" */
                "px-3 py-1.5 rounded-lg text-sm border transition-colors",
viewMode === "project-reports"
  ? "bg-gray-100 border-gray-300 text-gray-800"
  : "bg-white border-gray-200 text-gray-700 hover:bg-gray-50"
            )}
           // onClick={() => setViewMode("project-reports")}

          onClick={() => {
           pushUIState();
           setViewMode("project-reports");
            }}


          >
            📑 Reports
          </button>
        </div>
        )}
       
       <div className="flex items-center gap-2 text-sm text-gray-600">
          👤 {user?.userName ?? "User"}
        </div> 
       
        
      </div>

      {/* Project Content */}
     {/* <div className="flex-1 min-h-0 p-3 overflow-y-auto"> */}
     {/* //overflow-hidden*/}
     {/* Project Content */}
<div className={clsx(
  "flex-1 min-h-0",
  viewMode === "project-chat"
    ? "overflow-hidden"
    : "overflow-y-auto p-3"
)}>

        {viewMode === "project-chat" && <ProjectChat projectId={selectedProjectId} />}
       {/* {viewMode === "project-dashboard" && (
          <div className="text-gray-600">📈 Dashboard coming soon</div>
        )}*/}


        {viewMode === "project-dashboard" && (
  <ProjectDashboard projectId={selectedProjectId!} />
)}


        {viewMode === "project-reports" && <ProjectReports />}
       {viewMode === "project-gantt" && <ProjectGantt />}  {/* ✅ ADD THIS */}
       {viewMode === "material-statement" && <MaterialStatementReport />}
      {/*  {viewMode === "dpr-report" && <DprReport />}*/}
        
      {/*  {viewMode === "material-consumption" && <MaterialConsumptionReport />}*/}
      {/*  {viewMode === "daily-material-receipt" && (<DailyMaterialReceiptReport projectId={selectedProjectId!} />)}*/}
        {viewMode === "dpr-cumulative" && (<DprCumulativeReport projectId={selectedProjectId!} />)}
      {viewMode === "drs-notes-report" && (
  //<DRSNotesReport drsId={selectedProjectId!} />
  <DRSNotesReport
  projectId={selectedProjectId!}
 // date={selectedDate!}
/>

)}

{/*{viewMode === "dpr-daily-progress" && (
  <DailyProgressDprReport projectId={selectedProjectId!} />
)}

{viewMode === "site-progress" && (
  <WGSnapshotProgressReport projectId={selectedProjectId!} />
)}
{viewMode === "lookahead-progress-report" && (
  <LookAheadProgressReport />
)}
{viewMode === "statement-equipment-latest-plantin" && (
  <StatementEquipmentLatestPlantInReport />
)}
{viewMode === "statement-equipment-latest-plantout" && (
  <StatementEquipmentLatestPlantOutReport />
)}
{viewMode === "overall-schedule-status" && (
  <OverallScheduleStatus projectId={selectedProjectId!} />
)}

{viewMode === "material-disposed-summary" && (
  <MaterialDisposedSummary />
)}
{viewMode === "site-cash-payments" && (
  <SiteCashPaymentsReport projectId={selectedProjectId!} />
)}
{viewMode === "equipment-statement" && (
  <EquipmentStatementReport />
)}*/}

       {/* {viewMode === "manpower-statement" && (<ManPowerStatementReport projectId={selectedProjectId!} />)}*/}
       {/* {viewMode === "daily-total-workforce" && (<DailyTotalWorkforceReport projectId={selectedProjectId!} />)}*/}
{viewMode === "works-progress-report" && (
  <WorksQtyReport projectId={selectedProjectId!} />
)}

{viewMode === "group-report" && (
  <GroupProgressRangeReport projectId={selectedProjectId!} projectName={selectedProjectName!} />
)} 


{viewMode === "material-statement-vendor-wise" &&
        <MaterialStatementVendorWiseReport />}
{viewMode === "manpower-statement-vendor-wise" && (
  <ManPowerStatementVendorWiseReport projectId={selectedProjectId!} />
)}
{viewMode === "manpower-statement-resource-wise" && (
  <ManPowerStatementResourceWiseReport
    projectId={selectedProjectId!} 
     projectName={selectedProjectName!}
     />)}

     {viewMode === "equipment-statement-resource-wise" && ( <EquipmentStatementResourceWiseReport />)}
      {viewMode === "drawings-report" && ( <DrawingsReport projectId={selectedProjectId!}  projectName={selectedProjectName!} />)}
      {viewMode === "equipment-statement-vendor-wise" && (<EquipmentStatementVendorWiseReport />)}
      {viewMode === "weather-keyword-report" && (<WeatherKeywordReport />)}

      {viewMode === "task-report" && <TaskReportView />}

        {viewMode === "all-issues" && <AllIssues />}
      </div>
      {showNewIssueModal && (
          <NewIssueModal
            projectId={selectedProjectId!}
            onClose={() => setShowNewIssueModal(false)}
            onCreated={(issue) => {
              //
              pushUIState(); // ✅ ADD THIS LINE
              setSelectedIssueId(issue.taskId); // details page display
      
              setSelectedIssueTitle(issue.title);
              setViewMode("issue-details");
              setShowNewIssueModal(false);
          }}
        />
      )}
    </div>
  ); 
} 
